import { convertColorStringToRgb } from '@utils/css';
import { parseStyleAttribute } from '../util.parse-style-attribute.js';
import { textNodeToLatexPrinter } from './common.text.js';
import { htmlHeadingNodeToLatexPrinter } from './html.headings.js';
import { htmlListsNodesToLatexPrinter } from './html.lists.js';
import { htmlParagraphNodeToLatexPrinter } from './html.paragraph.js';
import { htmlTableNodesToLatexPrinter } from './html.table.js';

let currentColorId = 0;
function makeHtmlNodeToLatexPrinter(getPrinters) {
  let printers;
  const htmlNodeToMdPrinter = (node, context) => {
    var _a, _b, _c;
    if (!printers) {
      printers = getPrinters();
    }
    const printChildren = (children2) => {
      return context.printChildren(children2 ?? [], printers) ?? [];
    };
    const children = printChildren(node.children).join("");
    switch (node.tagName) {
      case "h1":
      case "h2":
      case "h3":
      case "h4":
      case "h5":
      case "h6":
        return htmlHeadingNodeToLatexPrinter(node, printChildren);
      case "ul":
      case "ol":
      case "li":
        return htmlListsNodesToLatexPrinter(node, printChildren);
      case "p":
        return htmlParagraphNodeToLatexPrinter(node, printChildren);
      case "table":
      case "thead":
      case "tbody":
      case "tr":
      case "th":
      case "td":
        return htmlTableNodesToLatexPrinter(node, printChildren);
      case "em":
      case "i":
        return `\\textit{${children}}`;
      case "b":
      case "strong":
        return `\\textbf{${children}}`;
      case "strikethrough":
        return `\\sout${children}`;
      case "u":
      case "ins":
        return `\\underline{${children}}`;
      case "sup":
        return `\\textsuperscript{${children}}`;
      case "sub":
        return `\\textsubscript{${children}}`;
      case "hr":
        return "\\noindent\\rule{\\textwidth}{1pt}\\\\";
      case "a":
        if (!((_a = node.attributes) == null ? void 0 : _a["href"])) {
          return children;
        }
        if (node.attributes["href"] === children) {
          return `\\url{${node.attributes["href"]}}`;
        }
        return `\\href{${node.attributes["href"]}}{${children.replaceAll("#", "\\#")}}`;
      case "img":
        if (!((_b = node.attributes) == null ? void 0 : _b["src"])) {
          return "";
        }
        if (node.attributes["data-latex"]) {
          return `\xA0\\\\
$${node.attributes["data-latex"]}$\xA0\\\\
`;
        }
        return `\\includegraphics[width=\\textwidth]{${node.attributes["src"]}}`;
      case "br":
        return "\xA0\\\\\n";
      case "audio":
      case "video":
      case "iframe":
        return null;
      case "div":
      case "span": {
        const styles = parseStyleAttribute(((_c = node.attributes) == null ? void 0 : _c["style"]) ?? "");
        const parsedColor = convertColorStringToRgb(styles == null ? void 0 : styles["color"]);
        const parsedBackground = convertColorStringToRgb(
          styles == null ? void 0 : styles["background-color"]
        );
        let output = children;
        if (parsedBackground && (parsedBackground.r !== 0 || parsedBackground.g !== 0 || parsedBackground.b !== 0)) {
          output = `\\definecolor{color-${++currentColorId}}{RGB}{${parsedBackground.r}, ${parsedBackground.g}, ${parsedBackground.b}} \\colorbox{color-${currentColorId}}{${children}}`;
        }
        if (parsedColor && (parsedColor.r !== 0 || parsedColor.g !== 0 || parsedColor.b !== 0)) {
          output = `\\definecolor{color-${++currentColorId}}{RGB}{${parsedColor.r}, ${parsedColor.g}, ${parsedColor.b}} \\textcolor{color-${currentColorId}}{${children}}`;
        }
        return output;
      }
      default:
        return children;
    }
  };
  return htmlNodeToMdPrinter;
}
const htmlNodeToLatexPrinter = makeHtmlNodeToLatexPrinter(() => ({
  text: textNodeToLatexPrinter,
  html: htmlNodeToLatexPrinter
}));

export { htmlNodeToLatexPrinter, makeHtmlNodeToLatexPrinter };
//# sourceMappingURL=common.html.js.map
